import { Injectable } from '@angular/core';
import {Endpoints} from "../../customs/endpoints";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {CommonResponse} from "../../customs/_models/Response";
import {ResultDTO} from "../../customs/_models/ResultDTO";
import { AnalyseResult } from '../analyse-service/analyse.service';
import { ResultImpDto } from '../../customs/_components/analyse/in-progress-analyses/in-progress-analyses.component';
@Injectable({
  providedIn: 'root'
})
export class ResultService {

    constructor(
        private endpoints: Endpoints,
        private http : HttpClient) { }

    public findAll(): Observable<CommonResponse>{
        const username = sessionStorage.getItem('user_name'); // Récupérer l'utilisateur connecté
        console.log(this.endpoints.results_base_endpoint)
        return this.http.get<CommonResponse>(`${this.endpoints.results_base_endpoint}?username=${username}`);

    }

    public save(result : ResultDTO) :Observable<CommonResponse> {
        return this.http.post<CommonResponse>(this.endpoints.results_base_endpoint,result)
    }

    public update(result : ResultDTO) :Observable<CommonResponse> {
        return this.http.put<CommonResponse>(this.endpoints.results_base_endpoint,result)
    }

    public calculerMultipleResult(results : ResultDTO[]) :Observable<CommonResponse> {
        return this.http.put<CommonResponse>(`${this.endpoints.results_base_endpoint}/calculerMultipleResult`,results)
    }
 public calculerMultipleResult1(results : AnalyseResult[]) :Observable<CommonResponse> {
        return this.http.put<CommonResponse>(`${this.endpoints.results_base_endpoint}/calculerMultipleResult`,results)
    }

    public delete(id : number) :Observable<CommonResponse> {
        return this.http.delete<CommonResponse>(`${this.endpoints.results_base_endpoint}/${id}`)
    }

    public gennerateResultFromAnalyse(analyseId : number) {
        return this.http.get<CommonResponse>(`${this.endpoints.results_base_endpoint}/createResultFromAnalyse/${analyseId}`)
    }

    saveFromTextFile(data : SampleData[]) {
        console.log(data)
        return this.http.post<CommonResponse>(this.endpoints.results_base_endpoint+'/saveFromTextFile',data)

    }

    createFromTextFile(data: SampleData[]) {
        console.log(data)
        return this.http.post<CommonResponse>(this.endpoints.results_base_endpoint+'/createTempo',data)
    }

    parseFileData(data: string): SampleData[] {
        const sections = data.split('[Sample Header]');
        const sampleDataArray: SampleData[] = [];

        sections.forEach(section => {
            if (section.trim()) {
                const lines = section.trim().split('\n');
                const headerLines = lines.slice(0, 9);
                const resultsStartIndex = lines.findIndex(line => line.includes('[Results]')) + 1;
                const resultsEndIndex = lines.findIndex(line => line.includes('[Internal Standards]'));
                const resultLines = lines.slice(resultsStartIndex, resultsEndIndex);
                const header = this.parseHeader(headerLines);
                const results = this.parseResults(resultLines);
                sampleDataArray.push({header, results});
            }
        });
        return sampleDataArray
    }

    private parseHeader(lines: string[]): SampleHeader {
        const header: any = {};
        lines.forEach(line => {
            const [key, value] = line.split('=');
            header[key.trim()] = value ? value.trim() : '';
        });
        return {
            method: header.Method,
            sampleName: header.SampleName,
            sampleType: header['Sample Type'],
        };
    }

    private parseResults(lines: string[]): Result[] {
        const results: Result[] = [];
        lines.forEach(line => {
            const values = line.split(',').map(v => v.trim());
            if (values.length === 8) {
                results.push({
                    elem: values[0],
                    unit: values[1],
                    avg: isNaN(parseFloat(values[2])) ? 0 : parseFloat(values[2]),
                });
            }
        });
        return results;
    }


    updateResultfromExcel(data: ResultDTO[]) {
        return this.http.post<CommonResponse>(this.endpoints.results_base_endpoint+'/update-final-result-from-excel',data)

    }
   updateResultfromExcel1(data: ResultImpDto[]) {
        return this.http.post<CommonResponse>(this.endpoints.results_base_endpoint+'/update-final-result-from-excel',data)

    }
    getFormuleById(id:number):Observable<any>{
        return this.http.get<any>(this.endpoints.formule_base_endpoint+'/'+id)
    }

    getFormule():Observable<any>{
        return this.http.get<any>(this.endpoints.formule_base_endpoint)
    }


}
interface SampleHeader {
    method: string;
    sampleName: string;
    sampleType: string;
}

interface Result {
    elem: string;
    unit: string;
    avg: number;
}

interface SampleData {
    header: SampleHeader;
    results: Result[];
}
